import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminJobDetailsPage } from '../../../../../components/pages/backoffice/platform/platform-admin-jobs-page/job-details-page/platform-admin-job-details-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/jobs/$jobId/')({
  component: function Component() {
    const { jobId } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['tech.configurations']}>
        <PlatformAdminJobDetailsPage jobId={jobId} />
      </PermissionChecker>
    )
  },
})
